export default {
    data() {
        return {
            visible: false,
            drawerWrapClassName: 'drawer-form',
        }
    },
    methods: {
        /*点击确定按钮*/
        onOk() {
            this.$emit('ok');
        },
        /*点击取消按钮*/
        onClose() {
            this.visible = false;
            this.$emit("onClose")

        },
    },
};
